var exports = {
  "Tj": "xfd349460--42b675--map",
  "Lg": "xfd349460--42b675--map-pin",
};

module.exports = exports;
